export const getData = () =>
    fetch('/api/v1/ai-prompts/', {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const enableKeyword = async (id) => {
    return fetch(`/api/v1/ai-prompts/${id}/enable/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const disableKeyword = async (id) => {
    return fetch(`/api/v1/ai-prompts/${id}/disable/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};

export const updateKeyword = async (id, data) => {
    return fetch(`/api/v1/ai-prompts/${id}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const bulkUpdateProject = async (data) => {
    return fetch('/api/v1/ai-prompts/bulk-change-project/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const bulkAddTags = async (data) => {
    return fetch('/api/v1/ai-prompts/bulk-update-tags/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const bulkDisablePrompts = async (data) => {
    return fetch('/api/v1/ai-prompts/bulk-disable/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const bulkActivatePrompts = async (data) => {
    return fetch('/api/v1/ai-prompts/bulk-activate/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const bulkUpdateFrequency = async (data) => {
    return fetch('/api/v1/ai-prompts/bulk-update-frequency/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
